import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import Footer from "../components/footer";
import Gotop from "../components/gotop";
import { Rating } from "react-simple-star-rating";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../assets/images/logo.png";
import Header2 from "../components/header/Header03";
import MobileHeader from "../components/header/MobileHeader";

EmployerReview.propTypes = {};

function EmployerReview(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);
  const [rating, setRating] = useState(0);
  const [status, setStatus] = useState("");

  const handleRating = (rate) => {
    setRating(rate);
  };

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };


  const location = useLocation();
  const query = new URLSearchParams(location.search);

  useEffect(() => {
    const status = query.get("status");

    setStatus(status);
  }, []);

  const handleContinueToPage = () => {
    const continueTo = localStorage.getItem("current-page") || "/";
    window.location.href = continueTo;
  };

  return (
    <>
      <MobileHeader handleMobile={handleMobile} />
      <Header2 clname="actEm4" handleMobile={handleMobile} />

      {status === "success" ? (<section>
        <div className="wrap-form-rating-page">
          <div className="wd-form-rating-page">
            <form action="/employerreview">
              <div className="form-title">
                <h1>Subscription Successful!</h1>
                <h4>
                  Your subscription has been activated successfully.
                </h4>
              </div>

              <Link onClick={handleContinueToPage} className="tf-btn-submit">Continue to article</Link>
            </form>

            <div className="row">

              <div className="col-lg-6 col-md-6">
                <div className="wd-review-job pt10 wow fadeInUp">
                  <ul className="list-review2">
                    <li className="active">
                      <h6>Discover New Opportunities</h6>
                      <p>
                        UK Immigration can be unstable. UKICNEWS.com helps you stay informed with our
                        timely updates on policy changes, visa regulations, and
                        application procedures.
                      </p>
                    </li>
                    <li>
                      <h6>Apply to Sponsorship Jobs</h6>
                      <p>
                        Searchin for COS sponsorship jobs can be time-consuming and
                        frustrating. UKICNEWS.com curates a list of real sponsorship job
                        opportunities, making it easier for you to find relevant
                        positions.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>)
        :
        (<section>
          <div className="wrap-form-rating-page">
            <div className="wd-form-rating-page">
              <form action="/employerreview">
                <div className="form-title">
                  <h1 className="text-danger">Subscription Cancelled/Failed!</h1>
                  <h4>
                    Your subscription was not successful. Please try again.
                  </h4>
                </div>

                <Link to="/pricing" className="tf-btn-submit">Continue</Link>
              </form>

              <div className="row">

                <div className="col-lg-6 col-md-6">
                  <div className="wd-review-job pt10 wow fadeInUp">
                    <ul className="list-review2">
                      <li className="active">
                        <h6>Discover New Opportunities</h6>
                        <p>
                          UK Immigration can be unstable. UKICNEWS.com helps you stay informed with our
                          timely updates on policy changes, visa regulations, and
                          application procedures.
                        </p>
                      </li>
                      <li>
                        <h6>Apply to Sponsorship Jobs</h6>
                        <p>
                          Searchin for COS sponsorship jobs can be time-consuming and
                          frustrating. UKICNEWS.com curates a list of real sponsorship job
                          opportunities, making it easier for you to find relevant
                          positions.
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>)}
      <Footer />
      <Gotop />
    </>
  );
}

export default EmployerReview;
